import { Flex } from 'antd'
import React from 'react'
import classnames from 'classnames'
import styles from './MobileEventRow.module.scss'

type Props = {
  text: string;
  type: 'success' | 'info' | 'warning';
}

export function MobileEventRow({ type, text }: Props) {
  return (
    <div className={classnames(styles.root, styles[type])}>
      <Flex align="center" gap={10}>
        {type === 'success' && <span className={styles.icon}>✅</span>}
        {type === 'info' && <span className={styles.icon}>👀</span>}
        {type === 'warning' && <span className={styles.icon}>🙁</span>}
        <p className={styles.content}>{text}</p>
        <span className={styles.close}>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.464844 9.30469C0.378906 9.22266 0.322266 9.125 0.294922 9.01172C0.267578 8.89844 0.267578 8.78516 0.294922 8.67188C0.326172 8.55859 0.382812 8.46289 0.464844 8.38477L4.0625 4.77539L0.464844 1.17188C0.382812 1.09375 0.328125 0.998047 0.300781 0.884766C0.273438 0.771484 0.273438 0.658203 0.300781 0.544922C0.328125 0.431641 0.382812 0.333984 0.464844 0.251953C0.550781 0.166016 0.650391 0.109375 0.763672 0.0820312C0.876953 0.0546875 0.990234 0.0546875 1.10352 0.0820312C1.2168 0.109375 1.31445 0.164062 1.39648 0.246094L5 3.84961L8.59766 0.246094C8.67969 0.160156 8.77734 0.105469 8.89062 0.0820312C9.00391 0.0546875 9.11523 0.0546875 9.22461 0.0820312C9.33789 0.109375 9.43945 0.166016 9.5293 0.251953C9.61133 0.333984 9.66602 0.431641 9.69336 0.544922C9.72461 0.658203 9.72461 0.771484 9.69336 0.884766C9.66602 0.994141 9.61133 1.0918 9.5293 1.17773L5.93164 4.77539L9.5293 8.37891C9.61133 8.46484 9.66602 8.56445 9.69336 8.67773C9.7207 8.78711 9.7207 8.89844 9.69336 9.01172C9.66602 9.125 9.61133 9.22266 9.5293 9.30469C9.44336 9.39062 9.34375 9.44727 9.23047 9.47461C9.11719 9.50195 9.00391 9.50195 8.89062 9.47461C8.77734 9.44727 8.67969 9.39258 8.59766 9.31055L5 5.70703L1.39648 9.31055C1.31445 9.39258 1.2168 9.44727 1.10352 9.47461C0.994141 9.50195 0.880859 9.50195 0.763672 9.47461C0.650391 9.44727 0.550781 9.39062 0.464844 9.30469Z" fill="#050510" />
          </svg>
        </span>
      </Flex>
    </div>
  )
}
